import { Component, Input, OnInit, OnChanges, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService, ExchangeService } from "@mypxplat/xplat/core";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-exchange-list",
  templateUrl: "exchange-list.component.html",
  standalone: false,
})
export class ExchangeListComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input() wares: any;
  @Input() displayedCategory: any;
  @Input() limit: number;
  @Input() showSearch: boolean = false;
  @Input() searchQuery: string;
  @Input() creator_id: any;
  @Input() searching: any;
  @Input() page: number = 1;
  @Input() filterCategories: any = [];
  @Input() unapproved: boolean = false;
  @ViewChild("pagingContainer", { static: false }) pagingContainer: ElementRef;
  paging: boolean = false;
  searchingAndHasShownMore: boolean = false;
  loading: boolean;
  @Output() clearSearchQuery: EventEmitter<boolean> = new EventEmitter();
  @Output() itemTapped: EventEmitter<number> = new EventEmitter();
  @Output() updateFavorites: EventEmitter<boolean> = new EventEmitter();
  @Output() filterByCategory: EventEmitter<string> = new EventEmitter();

  constructor(
    userService: UserService,
    public appService: AppService,
    public exchangeService: ExchangeService
  ) {
    super(userService);
  }

  ngOnInit() {
    window.removeEventListener("scroll", this.scrollEvent, true);
    window.addEventListener("scroll", this.scrollEvent, true);
    if (this.displayedCategory && this.displayedCategory.title != "myitems") this.exchangeService.cachedWares = this.wares;
  }

  scrollEvent = (args) => {
    let offset = window.pageYOffset + window.innerHeight - 300;
    if (this.searchQuery) {
      if (this.searchingAndHasShownMore) {
        if (offset >= this.pagingContainer.nativeElement.offsetTop) {
          if (this.wares.total > this.wares.data.length) this.nextPage();
        }
      }
    } else {
      if (offset >= this.pagingContainer.nativeElement.offsetTop) {
        if (this.wares.total > this.wares.data.length) this.nextPage();
      }
    }
  };

  exchangeItemTapped(args, id) {
    this.exchangeService.lastViewedElement = args.srcElement;
    const className = args.srcElement.className;
    const classList = typeof className === "string" ? className : Array.from(className).join(" ");
    if (classList.indexOf("fa-chevron-right") > -1 || (classList.indexOf("fa") == -1 && classList.indexOf("circle-icon-btn") == -1)) {
      this.itemTapped.next(id);
    }
  }

  listUpdateFavorites() {
    this.updateFavorites.next(true);
  }

  ngOnChanges(event) {
    if (event.searchQuery) {
      this.page = 1;
    }
  }

  nextPage() {
    if (this.paging) return;
    this.page++;
    this.paging = true;

    if (this.searchQuery) {
      if (!this.searchingAndHasShownMore) {
        this.limit = 25;
        this.page = 1;
      }
      this.exchangeService
        .search(this.searchQuery, this.limit, this.page)
        .pipe(finalize(() => (this.paging = false)))
        .subscribe((results: any) => {
          if (!this.searchingAndHasShownMore) {
            this.searchingAndHasShownMore = true;
            this.wares.data = results.data;
          } else {
            this.wares.data = [...this.wares.data, ...results.data];
          }
        });
      return;
    }

    if (this.unapproved) {
      this.exchangeService
        .getUnapprovedWares(this.limit, this.page)
        .pipe(finalize(() => (this.paging = false)))
        .subscribe((result: any) => {
          this.wares.data = [...this.wares.data, ...result.data];
          if (result.total != null) this.wares.total = result.total;
        });
      return;
    }

    if (!this.creator_id && this.displayedCategory && this.displayedCategory.title == "myitems") {
      this.creator_id = this.user.id;
    }
    this.exchangeService
      .getWares(this.limit, this.page, this.displayedCategory ? this.displayedCategory.title : false, this.creator_id)
      .pipe(finalize(() => (this.paging = false)))
      .subscribe((result) => {
        this.wares.data = [...this.wares.data, ...result.data];
        if (this.displayedCategory && this.displayedCategory.title != "myitems") this.exchangeService.cachedWares = this.wares;
      });
  }

  selectCategoryFilter(event) {
    this.filterByCategory.next(event.target.value);
  }

  ngOnDestroy() {
    window.removeEventListener("scroll", this.scrollEvent, true);
  }
}
